import { FaGithub, FaLinkedin } from 'react-icons/fa';

const Introduction = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-4 d-flex justify-content-center align-items-center">
          <img src="images/profile/profile-pic1.JPG" alt="Madhav Shukla" className="img-fluid" />
        </div>
        <div className="col-lg-8 d-flex flex-column justify-content-center align-items-start">
          <h1 style={{ fontWeight: 'bold' }}>
            <span style={{ backgroundColor: '#f5d742', padding: '5px' }}>M</span>adhav <span style={{ backgroundColor: '#f5d742', padding: '5px' }}>S</span>hukla
          </h1>
          <h2>Software Engineer | Full Stack Developer</h2>
          <p>
            Hi, I'm Madhav Shukla, a 🚀 software engineer with experience in developing 🌐 web applications using React, Angular,
            Node.js, and TypeScript. I'm passionate about creating 🙌 user-friendly and efficient software that makes an impact.
          </p>
          <p>
            My skills include React, Angular, Node.js, TypeScript, C++, and more. Check out my Github and LinkedIn profiles
            below for more information about my work. 🔍
          </p>
          <div className="d-flex justify-content-start">
            <a href="https://github.com/madhav592001" target="_blank" rel="noreferrer">
              <button type="button" className="btn btn-dark me-2" style={{ fontSize: '20px', fontWeight: 'bold' }}>
                <FaGithub className="me-2" />
                Github
              </button>
            </a>
            <a href="https://www.linkedin.com/in/madhav-shukla-9a3a19194" target="_blank" rel="noreferrer">
              <button type="button" className="btn btn-primary" style={{ fontSize: '20px', fontWeight: 'bold' }}>
                <FaLinkedin className="me-2" />
                LinkedIn
              </button>
            </a>
            <a href="/docs/Madhav-Shukla.pdf" download>
              <button type="button" className="btn btn-outline-secondary ms-2" style={{ fontSize: '20px', fontWeight: 'bold' }}>
                Download Resume
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Introduction;
